import { IOptionItem } from '@wyz/types';
import { Icon, Text } from '@wyz/ui';
import { DistributionPricingPolicyHelpers } from '~/purchase/helpers';
import {
  IDistributionExtraBonusDraft,
  IDistributionPricingPolicyBrand,
  IDistributionPricingPolicySeason,
} from '~/purchase/types';
/* eslint-disable @wyz/module/no-relative-import -- siblings are imported directly: going through
   the ~/purchase/components barrel would make this module depend on itself. */
import { ExtraBonusEditBar } from './extra-bonus-edit-bar';
import { ExtraBonusSupplierRow } from './extra-bonus-supplier-row';
/* eslint-enable @wyz/module/no-relative-import */

const { tintClass } = DistributionPricingPolicyHelpers;

type Props = {
  brand: IDistributionPricingPolicyBrand;
  seasons: IDistributionPricingPolicySeason[];
  metricCount: number;
  canSeeExtraBonus: boolean;
  canEditExtraBonus: boolean;
  isEdited: boolean;
  isSaving: boolean;
  draft: IDistributionExtraBonusDraft;
  bonusTypeOptions: IOptionItem[];
  onEdit: (brand: IDistributionPricingPolicyBrand) => void;
  onCancel: () => void;
};

/** One brand: its own row, then one row per supplier type. */
export function ExtraBonusBrandRows({
  brand,
  seasons,
  metricCount,
  canSeeExtraBonus,
  canEditExtraBonus,
  isEdited,
  isSaving,
  draft,
  bonusTypeOptions,
  onEdit,
  onCancel,
}: Props) {
  return (
    <>
      <tr className='extra-bonus-table__brand-row'>
        <td>
          {/* Reserved whether or not the CTA shows, so brands and supplier types line up. */}
          <span className='extra-bonus-table__edit-slot'>
            {canEditExtraBonus && !isEdited && (
              <button
                type='button'
                className='extra-bonus-table__edit'
                data-cy={`edit-${brand.brand}`}
                onClick={() => onEdit(brand)}
              >
                <Icon icon='pencil-line' size='xs' />
              </button>
            )}
          </span>
          <Text component='span' color='primary' weight='bold'>
            {brand.brand}
          </Text>
        </td>
        {canSeeExtraBonus && <td className='extra-bonus-table__hq' />}

        {isEdited ? (
          <ExtraBonusEditBar
            brand={brand.brand}
            colSpan={seasons.length * metricCount}
            bonusTypeOptions={bonusTypeOptions}
            isSaving={isSaving}
            onCancel={onCancel}
          />
        ) : (
          // The season tints run through the brand row, only its label side stays neutral.
          seasons.map((season) => (
            <td
              key={season.id}
              colSpan={metricCount}
              className={`extra-bonus-table__tint${tintClass(season)}`}
            />
          ))
        )}
      </tr>

      {brand.rows.map((row, rowIndex) => (
        <ExtraBonusSupplierRow
          key={row.supplierTypeId}
          brand={brand}
          row={row}
          rowIndex={rowIndex}
          seasons={seasons}
          canSeeExtraBonus={canSeeExtraBonus}
          isEdited={isEdited}
          draft={draft}
        />
      ))}
    </>
  );
}
